import { c as _c } from "react/compiler-runtime";
import { useFormatter } from "next-intl";
import { getPercentageDiff } from "@lib/util/get-precentage-diff";
import { HttpTypes } from "@medusajs/types";
import { clx } from "@medusajs/ui";
type LineItemPriceProps = {
  item: HttpTypes.StoreCartLineItem | HttpTypes.StoreOrderLineItem;
  style?: "default" | "tight";
  currencyCode: string;
};
const LineItemPrice = t0 => {
  const $ = _c(19);
  const {
    item,
    style: t1,
    currencyCode
  } = t0;
  const style = t1 === undefined ? "default" : t1;
  const {
    total,
    original_total
  } = item;
  const originalPrice = original_total;
  const currentPrice = total;
  const hasReducedPrice = currentPrice < originalPrice;
  const format = useFormatter();
  let t2;
  if ($[0] !== currencyCode || $[1] !== currentPrice || $[2] !== format || $[3] !== hasReducedPrice || $[4] !== originalPrice || $[5] !== style) {
    t2 = hasReducedPrice && <><p>{style === "default" && <span className="text-ui-fg-subtle">Original: </span>}<span className="line-through text-ui-fg-muted" data-testid="product-original-price">{format.number(originalPrice, {
            style: "currency",
            currency: currencyCode
          })}</span></p>{style === "default" && <span className="text-ui-fg-interactive">-{getPercentageDiff(originalPrice, currentPrice || 0)}%</span>}</>;
    $[0] = currencyCode;
    $[1] = currentPrice;
    $[2] = format;
    $[3] = hasReducedPrice;
    $[4] = originalPrice;
    $[5] = style;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== hasReducedPrice) {
    t3 = clx("text-base-regular", {
      "text-ui-fg-interactive": hasReducedPrice
    });
    $[7] = hasReducedPrice;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== currencyCode || $[10] !== currentPrice || $[11] !== format) {
    t4 = format.number(currentPrice, {
      style: "currency",
      currency: currencyCode
    });
    $[9] = currencyCode;
    $[10] = currentPrice;
    $[11] = format;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <span className={t3} data-testid="product-price">{t4}</span>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t2 || $[17] !== t5) {
    t6 = <div className="flex flex-col gap-x-2 text-ui-fg-subtle items-end"><div className="text-left">{t2}{t5}</div></div>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default LineItemPrice;